var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlueTwoTonedLocationPin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 24,
    viewBox: "0 0 16 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "locatie-pin-a",
    d: "M0,7.602 C0,11.8 3.469,16.812 8,24 C12.531,16.812 16,11.8 16,7.602 C16,3.403 12.198,0 8,0 C3.802,0 0,3.403 0,7.602 Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#40AEC2",
    xlinkHref: "#locatie-pin-a"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1F2B35",
    strokeWidth: 2,
    d: "M8,22.1232227 C14.1963933,12.2689642 15,10.6412362 15,7.602 C15,4.0426379 11.7370093,1 8,1 C4.26299068,1 1,4.0426379 1,7.602 C1,10.6412362 1.8036067,12.2689642 8,22.1232227 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1F2B35",
    d: "M8,11 C6.343,11 5,9.657 5,8 C5,6.343 6.343,5 8,5 C9.657,5 11,6.343 11,8 C11,9.657 9.657,11 8,11"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueTwoTonedLocationPin);
export default __webpack_public_path__ + "static/media/blue-two-toned-location-pin.6883a7b31223abb8492c29b5b175d450.svg";
export { ForwardRef as ReactComponent };